import * as fromDatatype from '../datatype-library/index';

export interface bl_sfa_sales_lead_file_upload_hdr_RowInterface {
 
  guid: fromDatatype.GuidDataFieldInterface;
  app_file_item_guid : fromDatatype.GuidDataFieldInterface;
  source_guid : fromDatatype.GuidDataFieldInterface;
  level : fromDatatype.IntegerDatatypeInterface;
  file_type : fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  code : fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.TextDatatypeInterface;
  description : fromDatatype.TextDatatypeInterface;
  file_size : fromDatatype.BigIntegerDatatypeInterface;
  import_format : fromDatatype.VarcharDatatypeInterface;
  process_status : fromDatatype.VarcharDatatypeInterface;
  error_message : fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status : fromDatatype.StatusDataFieldInterface
  revision : fromDatatype.GuidDataFieldInterface
  vrsn : fromDatatype.VarcharDatatypeInterface;
  
}

export class bl_sfa_sales_lead_file_upload_hdr_RowClass implements bl_sfa_sales_lead_file_upload_hdr_RowInterface {

  guid: fromDatatype.GuidDataFieldInterface;
  app_file_item_guid : fromDatatype.GuidDataFieldInterface;
  source_guid : fromDatatype.GuidDataFieldInterface;
  level : fromDatatype.IntegerDatatypeInterface;
  file_type : fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  code : fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.TextDatatypeInterface;
  description : fromDatatype.TextDatatypeInterface;
  file_size : fromDatatype.BigIntegerDatatypeInterface;
  import_format : fromDatatype.VarcharDatatypeInterface;
  process_status : fromDatatype.VarcharDatatypeInterface;
  error_message : fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status : fromDatatype.StatusDataFieldInterface
  revision : fromDatatype.GuidDataFieldInterface
  vrsn : fromDatatype.VarcharDatatypeInterface;

}
